export default {
    blueprint: [
      {
        name: "Layout",
        key: ["value"],
        type: "layout_type",
      }
    ]
  }